var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#333}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26 11c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-8c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM26 31c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-8c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM7.5 22.5C3.916 22.5 1 19.584 1 16s2.916-6.5 6.5-6.5S14 12.416 14 16s-2.916 6.5-6.5 6.5zm0-11C5.019 11.5 3 13.519 3 16s2.019 4.5 4.5 4.5S12 18.481 12 16s-2.019-4.5-4.5-4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 17a1 1 0 0 1-1-1c0-1.93 1.57-3.5 3.5-3.5a1 1 0 1 1 0 2c-.827 0-1.5.673-1.5 1.5a1 1 0 0 1-1 1z",
    style: {
      fill: "#008ad0"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.503 25.058a.996.996 0 0 1-.484-.126l-10.004-5.558a1 1 0 0 1 .97-1.748l10.004 5.558a1 1 0 0 1-.486 1.874zM12.501 14.5a1 1 0 0 1-.486-1.874l10.004-5.558a1 1 0 1 1 .97 1.749l-10.004 5.558c-.153.084-.32.125-.484.125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/SocialMedia.77add075904ee5aa8b102fb7817a9107.svg";
export { ForwardRef as ReactComponent };